<script setup>
import { __ } from '@/utils';
import Hint from '@components/hint.vue';
import { inject, ref } from 'vue';

const props = defineProps(['phone']);
const { setStep } = inject('form');

const simAndroid = ref(simPdfGuilds.sim_android);
const simIOS = ref(simPdfGuilds.sim_ios);
const htmlTopText = ref(simPdfGuilds.sim_new_line_top)
const htmlText = ref(simPdfGuilds.sim_new_line_text)
</script>
<template>
    <div class="congrats">
        <div class="congrats__inner">
            <div class="congrats__heading">
                <h3 class="gradient">{{ __('Your SIM card has been activated successfully!') }}</h3>
            </div>

            <div class="congrats__order-number">
                <p>
                    <strong>{{ __('line number') }} {{ props.phone }}</strong>
                </p>
            </div>
            <img :src="`${theme_path.url}/resources/images/svg/icon-sim-fly.svg`" alt="">
            <p class="fz20 mb70">
                <span dir="rtl" v-html="htmlTopText"></span>
            </p>

            <h5 class="fz18"><strong>{{ __('Still struggling? Use our guides') }}</strong></h5>

            <div class="guide-cta mb13">
                <div class="guide-cta__item">
                    <Hint />
                    <a :href="simAndroid" target="_blank" v-if="simAndroid">
                        {{ __('Android Guide') }}
                    </a>
                </div>
                <div class="guide-cta__item">
                    <Hint />
                    <a :href="simIOS" target="_blank" v-if="simIOS">
                        {{ __('IOS Guide') }}
                    </a>
                </div>
            </div>
            <span dir="rtl" v-html="htmlText"></span>
            <div class="success-cta-row">
                <a href="/activation" class="link-arrow link-arrow--dark" @click.prevent="setStep('initial')">
                    {{ __('Click to activate another SIM') }}
                </a><!-- /.btn -->
                <a href="/" class="btn btn--arrows w156">{{ __('Back to Home page') }}</a>
            </div>
        </div>
    </div>
</template>